module.exports = __webpack_public_path__ + "static/media/template.b8e2f3b3.svg";